/**
 * useVehicle - Manages vehicle state for DriverApp
 */
import { useState } from 'react';

export function useVehicle() {
  const [vehicles, setVehicles] = useState([]);
  const [otherVehicleForm, setOtherVehicleForm] = useState({ rego: '', vehicle_class: 'HV', gvm_kg: '' });
  const [vehicleLoading, setVehicleLoading] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(() => {
    try {
      const saved = localStorage.getItem('lawd_selected_vehicle');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });
  const [pendingVehicleSelection, setPendingVehicleSelection] = useState(null);
  const [radiusSelectionLoading, setRadiusSelectionLoading] = useState(false);

  return {
    vehicles, setVehicles,
    otherVehicleForm, setOtherVehicleForm,
    vehicleLoading, setVehicleLoading,
    selectedVehicle, setSelectedVehicle,
    pendingVehicleSelection, setPendingVehicleSelection,
    radiusSelectionLoading, setRadiusSelectionLoading,
  };
}
